import Icon from 'veui/components/Icon'

Icon.register({
  heart: {
    paths: [
      {
        d: 'M384 736a31.94 31.94 0 01-16.46-4.56c-3.4-2-84.14-50.83-165.87-130.45-48.53-47.28-87.34-95.71-115.34-143.94C50.28 395 32 332.88 32 272.55 32 157.55 124.29 64 237.74 64A203.46 203.46 0 01384 125.8 203.46 203.46 0 01530.26 64C643.71 64 736 157.55 736 272.55c0 60.33-18.28 122.41-54.33 184.5-28 48.23-66.81 96.66-115.34 143.94-81.73 79.62-162.47 128.41-165.87 130.45A31.94 31.94 0 01384 736zM237.74 128C159.58 128 96 192.84 96 272.55c0 48.72 15.25 99.79 45.34 151.79 24.93 43.08 59.94 86.79 104.07 129.91C300.84 608.42 357 648.1 384 666c27-17.9 83.15-57.58 138.59-111.75 44.13-43.12 79.14-86.83 104.07-129.91 30.09-52 45.34-103.07 45.34-151.79C672 192.84 608.42 128 530.26 128c-48.38 0-92.95 24.8-119.22 66.33a32 32 0 01-54.08 0C330.69 152.8 286.12 128 237.74 128z'
      }
    ],
    width: '768',
    height: '768'
  }
})
